import React, {
  Component, Fragment, lazy, Suspense,
} from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Modal } from 'react-bootstrap';
import { getRequest, postRequest } from '../../requestUtils';
import ResumeActions from './ResumeActions';
import Loading from '../common/Loading';
import InterestDetails from './InterestDetails';

import './ConsultantInterest.scss';

const TransferApplication = lazy(() => import('../common/TransferApplication'));

const renderLogistics = (daysAgo, fromOpportunity) => (
  <div className=" mb-3 ">
    {fromOpportunity
      && (
      <span className="badge badge-fallback-tertiary me-3 normal-font pull-right">
        OpenOpps
      </span>
      )}
    <p>{daysAgo}</p>
  </div>
);

class ConsultantInterest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      interest: props.interest,
      accepted: props.interest.accepted,
      rejected: props.interest.rejected,
      waitlisted: props.interest.waitlisted,
      project: props.project,
      showApplicationModal: false,
    };

    this.setInterestAndProject = this.setInterestAndProject.bind(this);
    this.handleRejectInterest = this.handleRejectInterest.bind(this);
    this.handleWaitlistInterest = this.handleWaitlistInterest.bind(this);
    this.handleAcceptInterest = this.handleAcceptInterest.bind(this);
    this.handleShowApplicationModal = this.handleShowApplicationModal.bind(this);
    this.handleCloseApplicationModal = this.handleCloseApplicationModal.bind(this);
    this.createNewProposal = this.createNewProposal.bind(this);
  }

  setInterestAndProject(callback = () => {}) {
    const { interest, interestId, csrfToken } = this.props;
    if (Object.keys(interest).length) {
      this.setState({ interest }, callback);
    } else {
      getRequest(
        `/consultant_interests/${interestId}`,
        {},
        csrfToken,
      )
        .then((response) => {
          this.setState({ interest: response.data }, callback);
        });
    }
  }

  createNewProposal() {
    const {
      csrfToken,
      createProposalPath,
    } = this.props;
    const { interest } = this.state;
    const pathInfo = createProposalPath.split('?');
    const pathPost = pathInfo[0];
    const pathParams = pathInfo[1];
    const params = {
      project_id: pathParams[0].split('=')[1],
      consultant_interest_id: interest.id,
    };

    postRequest(
      pathPost,
      params,
      csrfToken,
    ).then((response) => {
      this.props.createdProposal(response.data);
    });
  }

  handleShowApplicationModal() {
    this.setInterestAndProject(() => (
      this.setState({ showApplicationModal: true })
    ));
  }

  handleCloseApplicationModal() {
    this.setState({ showApplicationModal: false });
  }

  handleAcceptInterest() {
    const { acceptedCallback } = this.props;
    const { interest } = this.state;

    this.setState({
      accepted: true,
      rejected: false,
      waitlisted: false,
      showApplicationModal: false,
    });
    acceptedCallback(interest);
  }

  handleWaitlistInterest() {
    const { waitlistedCallback } = this.props;
    const { interest } = this.state;
    this.setState({
      accepted: false,
      rejected: false,
      waitlisted: true,
      showApplicationModal: false,
    });
    waitlistedCallback(interest);
  }

  handleRejectInterest() {
    const { rejectedCallback } = this.props;
    const { interest } = this.state;
    interest.rejected = true;
    this.setState({
      rejected: true,
      accepted: false,
      waitlisted: false,
      showApplicationModal: false,
    });
    rejectedCallback(interest);
  }

  renderInterestDetails() {
    const { interest, clorifyUrl } = this.props;
    return (
      <div className="mb-2">
        <h3 className="fs-hide normal-weight pd-5">
          <a href={interest.consultant_url} target="_blank" rel="noreferrer">{interest.consultant_name}</a>
          <a href={clorifyUrl} target="_blank" rel="noreferrer"> (view Clorify)</a>
        </h3>

        <br />
        <button
          className="primary btn btn-primary full-width"
          onClick={this.handleShowApplicationModal}
        >
          View Application
        </button>
      </div>
    );
  }

  renderShowInProposalTabButton() {
    return (
      <button
        className="proposal-tab-review-button"
        onClick={this.handleShowApplicationModal}
      >
        Review
      </button>
    );
  }

  renderApplicationModal() {
    const {
      csrfToken,
      opportunitiesUrl,
      projectUrl,
      projectResourceId,
      projectsOptions,
      interestId,
      cloraRepName,
    } = this.props;
    const {
      showApplicationModal, accepted, rejected, waitlisted, interest,
    } = this.state;
    const noAction = !accepted && !rejected && !waitlisted;
    const applicationProject = projectsOptions
      .find((project) => project.value === projectResourceId);
    const filteredProjects = projectsOptions
      .filter((project) => project.value !== projectResourceId);
    return (
      <Modal
        dialogClassName="consultant-interest-modal-container"
        className="style-guide"
        show={showApplicationModal}
        onHide={this.handleCloseApplicationModal}
        size="lg"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <InterestDetails
            project={interest.project}
            csrfToken={csrfToken}
            requestedHourlyRate={interest.response?.requested_hourly_rate}
            resume={{
              document_file_name: interest.resume_name,
              document_url: interest.resume_url,
            }}
            repView
            submitted
          />
          <Row className="mt-40">
            { !waitlisted && !rejected
              && (
              <Col xs={6}>
                <ResumeActions
                  consultant={interest.consultant_name}
                  project={interest.project_name}
                  formUrl={interest.update_state_url}
                  interestId={interest.id}
                  csrfToken={csrfToken}
                  opportunitiesUrl={opportunitiesUrl}
                  afterSubmit={this.handleWaitlistInterest}
                  projectUrl={projectUrl}
                  key={interest.id}
                  feedbackText={interest.internal_feedback_text}
                  action="Waitlist"
                  addlButtonStyle="right-align"
                  cloraRepName={cloraRepName}
                />
              </Col>
              )}
            { !accepted && !rejected
              && (
              <Col xs={6}>
                <ResumeActions
                  consultant={interest.consultant_name}
                  project={interest.project_name}
                  formUrl={interest.update_state_url}
                  interestId={interest.id}
                  csrfToken={csrfToken}
                  opportunitiesUrl={opportunitiesUrl}
                  afterSubmit={this.handleAcceptInterest}
                  projectUrl={projectUrl}
                  key={interest.id}
                  action="Accept"
                  addlButtonStyle={waitlisted ? 'right-align' : 'left-align'}
                />
              </Col>
              )}
            { !rejected
              && (
              <Col xs={noAction ? 12 : 6} className={noAction ? 'center-align' : ''}>
                { noAction && <div className="mt-2" /> }
                <ResumeActions
                  consultant={interest.consultant_name}
                  project={interest.project_name}
                  formUrl={interest.update_state_url}
                  interestId={interest.id}
                  csrfToken={csrfToken}
                  opportunitiesUrl={opportunitiesUrl}
                  afterSubmit={this.handleRejectInterest}
                  projectUrl={projectUrl}
                  key={interest.id}
                  rejectionReason={interest.internal_feedback_reason}
                  feedbackText={interest.internal_feedback_text}
                  action="Decline"
                />
              </Col>
              )}
            <Col xs={noAction ? 12 : 6} className={noAction ? 'center-align' : ''}>
              { noAction && <div className="mt-2" /> }
              <Suspense fallback={<Loading />}>
                <TransferApplication
                  triggerText="Move Interest to another project"
                  triggerType="link"
                  idKey="move-application-modal"
                  selectOptions={filteredProjects}
                  csrfToken={csrfToken}
                  applicationType="Consultant Interest"
                  interestResourceId={interestId}
                  applicationProject={applicationProject}
                />
              </Suspense>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }

  renderInterestStatus() {
    const { accepted, rejected, waitlisted } = this.state;

    if (rejected) {
      return (
        <div className="resume-rejected">
          Resume Rejected
        </div>
      );
    }

    return (
      <div>
        {waitlisted
          && (
          <div className="resume-waitlisted">
            Waitlist
          </div>
          )}
        {accepted
          && (
          <div className="resume-accepted">
            Resume Accepted
          </div>
          )}
      </div>
    );
  }

  render() {
    const { interest, showInProposalsTab } = this.props;
    const { accepted } = this.state;

    if (showInProposalsTab) {
      return (
        <Fragment>
          {this.renderShowInProposalTabButton()}
          {this.renderApplicationModal()}
        </Fragment>
      );
    }
    return (
      <div className="consultant-interest">
        {renderLogistics(interest.days_ago, true)}
        {this.renderInterestDetails()}
        <div className="mb-15">
          {accepted
          && (
          <button
            id="create-proposal"
            value="Create Proposal"
            onClick={this.createNewProposal}
            className="btn btn-secondary full-width"
          >
            Create Proposal
          </button>
          )}
        </div>
        {this.renderInterestStatus()}
        {this.renderApplicationModal()}
      </div>
    );
  }
}

ConsultantInterest.propTypes = {
  interest: PropTypes.shape({
    accepted: PropTypes.bool.isRequired,
    rejected: PropTypes.bool.isRequired,
    waitlisted: PropTypes.bool.isRequired,
  }),
  interestId: PropTypes.number,
  createProposalPath: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  opportunitiesUrl: PropTypes.string,
  projectUrl: PropTypes.string,
  acceptedCallback: PropTypes.func,
  rejectedCallback: PropTypes.func,
  waitlistedCallback: PropTypes.func,
  clorifyUrl: PropTypes.string,
  createdProposal: PropTypes.func,
  project: PropTypes.shape({}),
  showInProposalsTab: PropTypes.bool,
  projectsOptions: PropTypes.arrayOf(PropTypes.shape({})),
  projectResourceId: PropTypes.string,
};

ConsultantInterest.defaultProps = {
  acceptedCallback: () => null,
  waitlistedCallback: () => null,
  clorifyUrl: '',
  showInProposalsTab: false,
  interestId: null,
  interest: {},
  projectsOptions: [],
  projectResourceId: '',
};

export default ConsultantInterest;
